
import { Component, Vue } from "vue-property-decorator";
import MenuButton from "./MenuButton.vue";


@Component({
  components: {
    MenuButton,
  },
})
export default class MenuIngenieria extends Vue {
  // mounted() {
  //   console.log("Menu Ingenieria mounted");
  // }

  items = ["LINEALES", "URBANIZACION", "HIDRAULICAS", "INDUSTRIALES", "DEPORTIVAS", "ESTRUCTURAS", "GEOTECNIA", "PARQUES"];
  buttonText = [
      "1. OBRAS LINEALES",
      "2. OBRAS DE URBANIZACIÓN",
      "3. OBRAS HIDRAULICAS",
      "4. INSTALACIONES INDUSTRIALES",
      "5. INSTALACIONES DEPORTIVAS",
      "6. ESTRUCTURAS",
      "7. GEOTÉCNIA Y MEDIO AMBIENTE",
      "8. PARQUES TEMÁTICOS / PARQUES TECNOLÓGICOS"    ];

  itemRoute(idx: number) {
    return `/main/ingenieria/${this.items[idx].toLowerCase()}`;
  }

  calcOffset(idx: number): string {
    var of = idx * 31;
    return `${of}px`;
  }

}
